import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'

const module = 'printtypes'
let doc = {
  list: {
    name: 'Impression',
    headers: [
      { label: 'Nom', value: 'name' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['printtypes.create'], dispatch: `${module}/openForm` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['printtypes.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
    search: [
      { label: 'Nom', type: 'text', name: 'name' },
    ],
  },

  form: {
    name: "Type d'impression",
    fields: [
      { label: 'Titre', name: 'name', type: 'text', hint: "Comment vous souhaitez nommer ce type d'impression" },
    ],
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['printtypes.update'], dispatch: `${module}/update` },
      {
        icon: 'delete',
        isFlat: true,
        scope: ['printtypes.delete'],
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],

  },

  params: {
    fetchAll: {},
    fetchOne: {},
  },
}

export default crudmaker(module, apiClient, doc)
